<mat-card class="explicit-confirmation-card">
  <mat-card-header style="width: 100%">
    <mat-card-title>
      <span>{{ translateContent ? (title | translate) : title }}</span>

      <span class="spacer"></span>

      <button
        mat-icon-button
        matTooltip="{{ 'General.Close' | translate }}"
        (click)="onCancelButtonClick()"
      >
        <mat-icon>close</mat-icon>
      </button></mat-card-title
    >

    <mat-card-subtitle>
      <mat-divider class="divider"></mat-divider>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div style="text-align: justify">
      <p class="warning-text" *ngFor="let message of messages" style="display: flex;">
        <span class="material-icons" [style.color]="message.color" style="margin-right: 10px">
          {{ message.icon }}
        </span>
        <span style="display: inline-block"><markdown [data]="translateContent ? (message.message | translate) : message.message"></markdown></span>
      </p>
    </div>
    <ng-content select="[optional-template]"></ng-content>
    <div
      style="
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
      "
    >
      <label for="moveTankInput">
        {{ translateContent ? (inputLabelPrefix | translate) : inputLabelPrefix }}
        <span style="font-weight: bold; font-size: 1.1rem"
          >'{{ explicitConfirmationText | uppercase }}'</span
        >
        {{ translateContent ? (inputLabelSuffix | translate) : inputLabelSuffix }}
      </label>
      <mat-form-field style="max-width: 150px">
        <input
          id="moveTankInput"
          matInput
          [(ngModel)]="explicitTextInput"
          [required]="true"
          placeholder="{{ explicitConfirmationText | uppercase }}"
        />
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button mat-button (click)="onCancelButtonClick()">
      {{ translateContent ? (cancelButtonText | translate) : cancelButtonText }}
    </button>

    <span fxFlex></span>

    <button
      mat-raised-button
      [disabled]="explicitTextInput !== explicitConfirmationText?.toUpperCase()"
      class="add-new-item-button"
      color="primary"
      (click)="
        explicitTextInput === explicitConfirmationText?.toUpperCase()
          ? onConfirmButtonClick()
          : null
      "
    >
      {{ translateContent ? (confirmButtonText | translate) : confirmButtonText }}
    </button>
  </mat-card-actions>
</mat-card>
